import { z } from 'zod';

import { makeEndpoint } from '../common';

export const AlaskaGetMemberResponseSchema = z.object({
  TopRankedBankCardDesignatorCode: z.string(),
  TopRankedBankCardDesignator: z.string(),
  SpecialPrograms: z
    .array(
      z.object({
        Code: z.string(),
        ProgramName: z.string(),
        Status: z.string(),
        StartDate: z.string(),
        EndDate: z.string(),
      }),
    )
    .optional(),
  LoyaltyDetails: z.object({
    LoyaltyNumber: z.string(),
    StatusPoints: z.number(),
    PreviousYearStatusPoints: z.number(),
    MemberBalance: z.number(),
    Tier: z.object({
      Code: z.string(),
      Description: z.string(),
      TierEndDate: z.string(),
      TierStartDate: z.string(),
    }),
  }),
  MemberProfile: z.object({
    DateOfBirth: z.string(),
    LastProcessedTransactionDateTime: z.string(),
    ZipCode: z.string(),
    CountryCode: z.string(),
    RegionCode: z.string(),
    AccountCreationDate: z.string(),
    ContactEmail: z.string(),
    FirstName: z.string(),
    LastName: z.string(),
    MemberType: z.string(),
    MemberStatus: z.string(),
    FraudAlertFlag: z.boolean(),
    IsValid: z.boolean(),
    StatusMessage: z.string(),
  }),
});

export const AlaskaGetMemberSchema = z.object({
  loyaltyNumber: z.string(),
});

export const AlaskaGetMemberEndpoint = makeEndpoint({
  method: 'GET',
  url: () => 'alaska/member/profile',
  requestSchema: AlaskaGetMemberSchema,
  responseSchema: AlaskaGetMemberResponseSchema,
});
